<template>
  <div class="row">
    <div class="col-lg-12">
      <h2 class="inline">Asset Under-repair Report</h2>
      <p class="describe">Asset Progress Report</p>
    </div>
    <div class="col-lg-4">
      <h4>
        Select Site:
        <el-select
          class="select-primary tab style-select"
          placeholder="Single Select"
          v-model="selects.simple_site"
          @change="getSite()"
        >
          <el-option
            v-for="option in selects.site"
            class="select-primary"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>

    <div class="col-lg-4 style-select">
      <h4>
        Select Owner:
        <el-select
          class="select-primary tab"
          placeholder="Single Select"
          v-model="selects.simple_owner"
          @change="getOwner()"
        >
          <el-option
            v-for="option in selects.owner"
            class="select-primary"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>

    <div class="col-lg-12">
      <hr />
    </div>
    <div class="col-md-12">
      <card card-body-classes="table-full-width">
        <div
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <base-input label="rows visible">
            <el-select
              class="select-info mb-3 pagination-select"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </base-input>
          <base-input>
            <el-input
              type="search"
              class="mb-3 search-input"
              clearable
              prefix-icon="el-icon-search"
              placeholder="Search records"
              v-model="searchQuery"
              aria-controls="datatables"
            ></el-input>
          </base-input>
        </div>
        <el-table
          :data="queriedData"
          :header-cell-style="{
            background: 'transparent',
            border: 'none',
            borderBottom: '0.5px solid #3d3f51',
          }"
          :cell-style="{
            border: 'none',
            borderBottom: '0.5px solid #3d3f51',
          }"
        >
          <el-table-column
            min-width="70"
            sortable
            align="center"
            label="Asset No"
            property="assetNo"
          ></el-table-column>
          <el-table-column
            min-width="110"
            sortable
            align="center"
            label="Asset Description"
            property="assetDescription"
          ></el-table-column>
          <el-table-column
            min-width="110"
            sortable
            align="center"
            label="Site"
            property="site"
          ></el-table-column>
          <el-table-column
            min-width="110"
            sortable
            align="center"
            label="Cost Center Name"
            property="costCenterName"
          ></el-table-column>
          <el-table-column
            min-width="110"
            sortable
            align="center"
            label="ETD Date"
            property="etddate"
          ></el-table-column>
          <el-table-column
            min-width="130"
            sortable
            align="center"
            label="Next Maintenance Date"
            property="nextmaintenancedate"
          ></el-table-column>
          <el-table-column
            min-width="110"
            sortable
            align="center"
            label="Owned By Name"
            property="ownedByName"
          ></el-table-column>
        </el-table>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></base-pagination>
        </div>
      </card>
    </div>
    <div class="col-lg-12 text-right">
      <base-button type="primary" @click="exportCSV()"
        >Export to CSV</base-button
      >
    </div>
  </div>
</template>
<script>
import config from "@/config";
import { Table, TableColumn } from "element-ui";
import { Select, Option, DatePicker } from "element-ui";
import Fuse from "fuse.js";
import { BasePagination } from "src/components";
import moment from "moment";
import { Circle8 } from "vue-loading-spinner";
import swal from "sweetalert2";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    Circle8,
  },
  data() {
    return {
      load: false,
      // Selecting interval data
      selects: {
        simple_owner: "",
        simple_site: "",
        simple_vehicleType: "",
        site: [
          { value: "All", label: "All" },
          { value: "Klang Valley", label: "Klang Valley" },
          { value: "Klang Valley", label: "KLIA" },
        ],
        owner: [
          { value: "All", label: "All" },
          { value: "ICWS", label: "ICWS" },
        ],
        vehicleType: [
          { value: "All", label: "All" },
          { value: "Compactor", label: "Compactor" },
          { value: "Arm Roll", label: "Arm Roll" },
        ],
      },
      value1: "",
      tableData: [
        {
          id: 1,
          assetNo: "Asset 123",
          assetDescription: "Scrubber",
          site: "KLIA",
          totalRepair: "4",
        },
        {
          id: 2,
          assetNo: "Asset 123",
          assetDescription: "Scrubber",
          site: "KLIA",
          totalRepair: "4",
        },
        {
          id: 3,
          assetNo: "Asset 123",
          assetDescription: "Scrubber",
          site: "KLIA",
          totalRepair: "4",
        },
        {
          id: 4,
          assetNo: "Asset 123",
          assetDescription: "Scrubber",
          site: "KLIA",
          totalRepair: "4",
        },
        {
          id: 5,
          assetNo: "Asset 123",
          assetDescription: "Scrubber",
          site: "KLIA",
          totalRepair: "4",
        },
      ],
      tempSite: [],
      tempOwner: [],
      searchQuery: "",
      propsToSearch: ["assetNo", "costCenterName"],
      // tableData: [],
      searchedData: [],
      fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
    };
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      console.log(value);
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: [
          "assetNo",
          "costCenterName",
          "assetDescription",
          "site",
          "ownedByName",
        ],
        threshold: 0.3,
      });
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
      console.log(this.searchedData);
    },
  },
  mounted() {},
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  created() {
    this.getCorrectMaintenance();
  },
  methods: {
    exportCSV() {
      let csvData = this.$CSV(this.tableData);
      const blob = new Blob([csvData], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute("download", "CorrectMaintenanceReport.csv");
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    getOwner() {
      this.load = true;
      this.searchQuery = "";
      console.log(this.selects.simple_owner);
      let temp = [];
      for (var i = 0; i < this.tempOwner.length; i++) {
        if (this.selects.simple_owner == this.tempOwner[i].ownedByName) {
          let obj = {
            assetNo: this.tempOwner[i].assetNo,
            assetDescription: this.tempOwner[i].assetDescription,
            site: this.tempOwner[i].site,
            costCenterName: this.tempOwner[i].costCenterName,
            etddate: this.tempOwner[i].etddate,
            nextmaintenancedate: this.tempOwner[i].nextmaintenancedate,
            ownedByName: this.tempOwner[i].ownedByName,
          };
          temp.push(obj);
        }
      }
      this.tableData = temp;
      this.searchedData = temp;
      this.load = false;
    },
    getSite() {
      this.load = true;
      this.searchQuery = "";
      console.log(this.selects.simple_site);
      let temp = [];
      let filter = [];
      this.selects.owner = [];
      this.selects.simple_owner = "";
      this.tempOwner = [];
      for (var i = 0; i < this.tempSite.length; i++) {
        if (this.selects.simple_site == this.tempSite[i].site) {
          let obj = {
            assetNo: this.tempSite[i].assetNo,
            assetDescription: this.tempSite[i].assetDescription,
            site: this.tempSite[i].site,
            costCenterName: this.tempSite[i].costCenterName,
            etddate: this.tempSite[i].etddate,
            nextmaintenancedate: this.tempSite[i].nextmaintenancedate,
            ownedByName: this.tempSite[i].ownedByName,
          };
          temp.push(obj);
          this.tempOwner.push(obj);
          //filter
          filter.push(this.tempSite[i].ownedByName);
        }
      }
      this.tableData = temp;
      this.searchedData = temp;

      //filter
      let filter2 = [];
      for (var i = 0; i < filter.length; i++) {
        if (filter2.indexOf(filter[i]) === -1) {
          filter2.push(filter[i]);
        }
      }
      for (var i = 0; i < filter2.length; i++) {
        let data = {
          label: filter2[i],
          value: filter2[i],
        };
        this.selects.owner.push(data);
      }
      this.load = false;
    },
    getCorrectMaintenance() {
      this.load = true;
      this.tableData = [];
      let temp = [];
      this.selects.site = [];
      this.searchedData = [];
      this.$http.get(":9996/api/v1/report/correctMaintenance").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let ETDdate = moment(response[i].EtdDate).format("YYYY-MM-DD");
            let nextMaintenanceDate = moment(
              response[i].NextMaintenanceDate
            ).format("YYYY-MM-DD");
            if (ETDdate == "Invalid date") {
              ETDdate = "-";
            }
            if (nextMaintenanceDate == "Invalid date") {
              nextMaintenanceDate = "-";
            }
            let obj = {
              assetNo: response[i].AssetNo,
              assetDescription: response[i].AssetDesc,
              site: response[i].SiteName,
              costCenterName: response[i].CostCenterName,
              etddate: ETDdate,
              nextmaintenancedate: nextMaintenanceDate,
              ownedByName: response[i].OwnedByName,
            };
            this.tableData.push(obj);
            this.tempSite.push(obj);
            this.searchedData.push(obj);
            //filter
            temp.push(response[i].SiteName);
          }

          // filter
          let filter = [];
          for (var i = 0; i < temp.length; i++) {
            if (filter.indexOf(temp[i]) === -1) {
              filter.push(temp[i]);
            }
          }
          for (var i = 0; i < filter.length; i++) {
            let data = {
              label: filter[i],
              value: filter[i],
            };
            this.selects.site.push(data);
          }
          this.load = false;
        } else {
          swal({
            title: "Opps! something went wrong",
            text: res.message,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
          this.load = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
  margin-bottom: 0.5%;
}
hr {
  color: black;
  margin-top: 0%;
}
.style-date {
  margin-bottom: 1%;
}
.style-select {
  padding-top: 1%;
}
.describe {
  font-size: 90%;
  font-style: italic;
}
</style>
